import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

export function Section({
  title,
  eyebrow,
  description,
  action,
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement> & {
  title?: ReactNode;
  eyebrow?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <section className={cn('mt-12 first:mt-0', className)} {...props}>
      {(title || eyebrow || action) && (
        <header className="flex items-end justify-between gap-4 mb-6">
          <div>
            {eyebrow ? <div className="smallcaps text-graphite mb-1.5">{eyebrow}</div> : null}
            {title ? (
              <h2 className="font-display text-2xl md:text-[28px] leading-tight tracking-snug">
                {title}
              </h2>
            ) : null}
            {description ? (
              <p className="mt-2 max-w-2xl text-graphite text-[15px] leading-relaxed">
                {description}
              </p>
            ) : null}
          </div>
          {action ? <div className="flex-shrink-0">{action}</div> : null}
        </header>
      )}
      {children}
    </section>
  );
}

export function Card({
  className,
  padding = 'md',
  ...props
}: HTMLAttributes<HTMLDivElement> & { padding?: 'sm' | 'md' | 'lg' }) {
  const padMap = { sm: 'p-4', md: 'p-6', lg: 'p-8' };
  return <div className={cn('surface', padMap[padding], className)} {...props} />;
}
